import '../css/app.css';
import './bootstrap';

import { createInertiaApp } from '@inertiajs/react';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { createRoot } from 'react-dom/client';
import { ToastProvider } from '@/Contexts/ToastContext';
import { ModalConfirmationProvider } from './Contexts/ModalConfirmationContext';
import { ProfilePictureProvider } from '@/Contexts/ProfilePictureContext';
import ErrorModalWrapper from '@/Components/ErrorModalWrapper';

const appName = import.meta.env.VITE_APP_NAME || 'e-KaBIT';

// Get the base URL from environment or use HTTP for local development
const appUrl = import.meta.env.VITE_APP_URL || 'http://localhost:8000';

// CSRF token handling is now managed in bootstrap.js

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    // Add this line to explicitly set the base URL
    resolve: async (name) => {
        const customPages = {
            'View/Landingpage': () => import('./Pages/View/landingpage.jsx'),
            'View/About': () => import('./Pages/View/About.jsx'),
            'View/LandingPageAnnouncement': () => import('./Pages/View/LandingPageAnnouncement.jsx'),
            'Services/Service': () => import('./Pages/Services/Service.jsx'),
        };

        let pageModule;

        if (customPages[name]) {
            pageModule = await customPages[name]();
        } else {
            pageModule = await resolvePageComponent(`./Pages/${name}.jsx`, import.meta.glob('./Pages/**/*.jsx'));
        }

        const PageComponent = pageModule.default;

        return {
            ...pageModule,
            default: (props) => (
                <ErrorModalWrapper>
                    <PageComponent {...props} />
                </ErrorModalWrapper>
            ),
        };
    },
    setup({ el, App, props }) {
        const root = createRoot(el);
        root.render(
            <ModalConfirmationProvider>
                <ToastProvider>
                    <ProfilePictureProvider>
                        <App {...props} />
                    </ProfilePictureProvider>
                </ToastProvider>
            </ModalConfirmationProvider>
        );
    },
    progress: {
        color: '#9ba4b1ff',
        showSpinner: false, // Disable spinner for faster perceived performance
    },
    // Enhanced error handling for function reference issues
    onError: (error) => {
        // Only log non-419 errors
        if (error.response?.status !== 419) {
            console.error('Inertia error:', error);
        }
        
        // Handle function reference errors in production
        if (typeof error === 'string' && error.includes('is not a function')) {
            if (import.meta.env.DEV) console.warn('Function reference error detected, reloading page...');
            window.location.reload();
        }
    },
});
